// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/widgets/Header/styles.scss
// module id = 806
// module chunks = 0